import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";
import { Paginator } from "primereact/paginator";
import CONF from "../../config/appProperties";
import { timesheetApi, Util } from "../../services";
import { TabView, TabPanel } from "primereact/tabview";
import EmployeeManagerTimesheet from "./employee-manager-timesheet";
import RejectTimesheetPopup from "./dialogBox/rejectTimesheetPopup";
import { toast } from "react-toastify";
import { Dialog } from "primereact/dialog";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { TIMESHEET_STATUS, titleCase } from "./helper";
import { Chip } from "primereact/chip";
import "primeicons/primeicons.css";
import { useLocation } from "react-router-dom";
import properties from "../../config/environmentProperties";
import { Calendar } from "primereact/calendar";
import CreateUserTimesheetByManager from "./create-user-timesheet-by-manager";
import InvoiceTimesheet from "./invoice-timesheets";
import ApproveTeamTimesheet from "./approved-team-timesheet";
import LockedTeamTimesheet from "./locked-team-timesheet";
import ReviewRecallTimesheet from "./review-recall-timesheet";
import { useNavigate } from "react-router";
import moment from "moment";
import { Menu } from "primereact/menu";
import { Toolbar } from "primereact/toolbar";
import ReviewTeamTimesheet from "./review-team-timesheet";
import DayWiseTimesheetReport from "./day-wise-timesheet-report";

import { TIMESHEET_INVOICE_VIEW, TIMESHEET_TEAM_APPROVALS, TIMESHEET_TEAM_COMPLIANCE, TIMESHEET_TEAM_USERWISE, TIMESHEET_TEAM_DAYWISE } from "../../config/permissions";
import ProtectedSection from "../../components/protected/ProtectedSection";
import { hasPermission } from "../../components/protected/ProtectedSection";
import { Checkbox } from "primereact/checkbox";

const ManagerTimesheet = () => {
  const [selectedTimesheetIds, setSelectedTimesheetIds] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [rejectedType, setRejectedType] = useState("");
  const menu = useRef(null);
  const { search } = useLocation();
  const urlActions = new URLSearchParams(search).get("action");
  const navigate = useNavigate();
  const [totalRecords, setTotalRecords] = useState(0);
  const [basicFirst, setBasicFirst] = useState(0);
  const [basicRows, setBasicRows] = useState(10);
  const [rowsPerPageOptions, setRowsPerPageOptions] = useState(CONF.rowsPerPageOptions);
  const [teamTimesheetList, setTeamTimesheetList] = useState([]);
  const [selectedTimesheet, setSelectedTimesheet] = useState([]);
  const [empReviewTimesheetList, setEmpReviewTimesheetList] = useState([]);
  const [compliance, setCompliance] = useState(false);
  const [complianceData, setComplianceData] = useState([]);
  const [compMonth, setCompMonth] = useState(new Date());
  const dt = useRef(null);
  const [teamTimesheet, setTeamTimesheet] = useState(true);
  const [reviewTimesheet, setReviewTimesheet] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const [usersBySuperior, setUsersBySuperior] = useState([]);
  const [rejectDialog, setRejectDialog] = useState(false);
  const [imapctBillableDialog, setImapctBillableDialog] = useState(false);
  const [rejectRowData, setRejectRowData] = useState({});
  const [userRejectData, setUserRejectData] = useState(false);
  const [rowClick, setRowClick] = useState(false);
  const [timesheetCtreatedUserId, setTimesheetCtreatedUserId] = useState("");
  const imgPath = properties.currentEnvironment.docPath + "images/";
  const [showCalender, setshowCalender] = useState(false);
  const [dateRange, setDateRange] = useState([]);
  const [filledTimesheet, setfilledTimesheet] = useState(true);
  let statusAcn = new URLSearchParams(search).get("status");
  const [userWiseTimesheet, setUserWiseTimesheet] = useState(false);
  const [dayWiseReport, setDayWiseReport] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const [reviewStatus, setReviewStatus] = useState(false);
  const [clickedForApprovedRow, setClickedForApprovedRow] = useState([]);
  const [clickedForApprovedRowType, setClickedForApprovedRowType] = useState();

  const [totalComplianceRecords, setTotalComplianceRecords] = useState(0);
  const [contentComplianceFirst, setContentComplianceFirst] = useState(0);
  const [pageCompliance, setPageCompliance] = useState(0);
  const [sizeCompliance, setSizeCompliance] = useState(CONF.pageSize);
  const [basicComplianceFirst, setBasicComplianceFirst] = useState(0);
  const [basicComplianceRows, setBasicComplianceRows] = useState(10);
  const [rowsPerPageComplianceOptions, setRowsPerPageComplianceOptions] = useState(CONF.rowsPerPageOptions);
  const [calenderMonth, setCalenderMonth] = useState('');
  const [calenderYear, setCalenderYear] = useState('');

  let count = 0;
  useEffect(() => {
    if (!hasPermission(TIMESHEET_TEAM_APPROVALS)) {
      setTimeout(() => {
        complianceClick(complianceData, "complianceData" + moment(new Date(compMonth), "DD-YYYY"));
      }, 100)
    }

    if (count == 0) {
      count++;
      if (urlActions === "app") {
        const userId = new URLSearchParams(search).get("id");
        setSelectedTab(1);
        getUserInfoBySuperiorIdList();
        setCompliance(false);
        setfilledTimesheet(false);
        setDayWiseReport(false);
        setUserWiseTimesheet(true);
      }
    }
  }, [reviewStatus]);

  /* Team timeshet Data Start */
  const fetchTeamTimesheetData = (param = {}) => {
    timesheetApi.getTeamTimesheetsData(param).then((resp) => {
      try {
        const data = resp.data.data.map((x) => {
          x["totalHour"] = 0;
          x["proHance"] = 0;
          x["startDate"] = null;
          x["endDate"] = null;
          x["fullName"] = titleCase(x.firstName + " " + x.lastName);
          x["totalHour"] += x?.totalHours;
          x.Timesheets.map((t, i) => {
            x["proHance"] += t.prohanceHours;
            if (i == 0) x["startDate"] = t.date;
            if (i == x.Timesheets.length - 1) x["endDate"] = t.date;
          });
          return x;
        });
        setTeamTimesheetList(data);
      } catch (error) {
        // Error handle
      }
    });
  };
  /* Team timeshet Data End */

  /* Approve Reject Team Members Timesheet Start */

  const handleCheckboxChange = (e, timesheetId) => {
    if (e.target.checked) {
      setSelectedTimesheetIds(prev => [...prev, timesheetId]);
    } else {
      setSelectedTimesheetIds(prev => prev.filter(id => id !== timesheetId));
    }
  };


  const groupByUserName = (entries) => {
    return entries?.reduce((acc, entry) => {
      if (!acc[entry.userName]) {
        acc[entry.userName] = [];
      }
      acc[entry.userName].push(entry);
      return acc;
    }, {});
  };

  const BillableImpactDialog = () => {
    let lhEntries;
    const entries = [];
    if (clickedForApprovedRowType === 1) {
      selectedTimesheet?.forEach(user => {
        user.Timesheets?.forEach(ts => {
          const isLH = ts?.TimesheetDetails?.some(detail => detail?.categories?.code === "LH");
          if (isLH) {
            entries.push({
              id: ts.id,
              date: ts.date,
              userName: `${user.firstName} ${user.lastName}`
            });
          }
        });
      });
      lhEntries = entries;
    }

    if (clickedForApprovedRowType === 2) {
      lhEntries = currentData?.Timesheets?.filter(timesheet =>
        timesheet?.TimesheetDetails.some(detail => detail?.categories?.code === "LH")
      ).map(ts => ({
        date: ts.date,
        id: ts.id,
        userName: `${currentData.fullName}`
      }));
    }
    const groupedLhEntries = groupByUserName(lhEntries);
    // const lhEntries = currentData?.Timesheets?.filter(timesheet =>
    //   timesheet?.TimesheetDetails.some(detail => detail?.categories?.code === "LH")
    // ).map(ts => ({
    //   date: ts.date,
    //   id: ts.id
    // }));

    return (
      <Dialog
        className="pop-up-dialog-recall"
        header="Billable Impact Timesheet"
        visible={imapctBillableDialog}
        style={{ width: '700px' }}
        onHide={() => setImapctBillableDialog(false)}
      >
        <div className="missing-attendance-dates">
          {groupedLhEntries && Object.entries(groupedLhEntries).map(([userName, entries]) => (
            <div key={userName} style={{ marginBottom: '1rem' }}>
              <h4>{userName}</h4>
              <ul>
                {entries.map((e) => (
                  <li key={e.id} className={"D-" + moment(e?.date, "DD-MM-YYYY").format("ddd")}>
                    <label>
                      <input
                        type="checkbox"
                        onChange={(event) => handleCheckboxChange(event, e.id)}
                        checked={selectedTimesheetIds.includes(e.id)}
                        style={{ marginRight: '5px' }}
                      />
                      <span>{moment(e?.date, "DD-MM-YYYY").format("ddd DD-MM-YYYY")}</span>
                    </label>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <span>
            If you want to make as billable activity on above leaves, please select them and submits!
          </span>
          <Button className="ml-4" label="Submit" onClick={updateBillableActivity}></Button>
        </div>
      </Dialog>
    )

    // return (
    //   <Dialog className="pop-up-dialog-recall" header="Billable Impact Timesheet" visible={imapctBillableDialog} style={{ width: '700px' }} onHide={() => setImapctBillableDialog(false)}>
    //     <div className="missing-attendance-dates">
    //       <ul>
    //         {lhEntries?.map((e) => (
    //           <li key={e.id} className={"D-" + moment(e?.date).format('ddd')}>
    //             <label>
    //               <input
    //                 type="checkbox"
    //                 onChange={(event) => handleCheckboxChange(event, e.id)}
    //                 checked={selectedTimesheetIds.includes(e.id)}
    //               />
    //               <span>{moment(e?.date).format('ddd MM-DD-YYYY')}</span>
    //             </label>
    //           </li>
    //         ))}
    //       </ul>
    //       <span>If you want to make as billable activity on above leaves, please select them and submit!</span>
    //       <Button className="ml-4" label="Submit" onClick={updateBillableActivity}></Button>
    //     </div>
    //   </Dialog>
    // );
  };

  const updateBillableActivity = () => {
    let statusType = "APPROVED";
    var dataObj = [];
    if (clickedForApprovedRowType === 1) {
      selectedTimesheet.map((item, key) => {
        var timeSheetIdList = [];
        for (let key in item.Timesheets) {
          timeSheetIdList.push(item.Timesheets[key].id);
        }

        const filteredArray = selectedTimesheetIds.filter(id => timeSheetIdList.includes(id));
        let ObjData = Object.assign({
          reason: statusType,
          status: statusType,
          userId: item.id,
          timesheet: timeSheetIdList,
          billableTimesheet: filteredArray,
        });
        dataObj.push(ObjData);
      });
    }
    if (clickedForApprovedRowType === 2) {
      let timeSheetIdList = [];
      for (let key in clickedForApprovedRow.Timesheets) {
        timeSheetIdList[key] = clickedForApprovedRow.Timesheets[key].id;
      }
      let ObjData = {
        reason: statusType,
        status: statusType,
        userId: clickedForApprovedRow.id,
        timesheet: timeSheetIdList,
        billableTimesheet: selectedTimesheetIds,
      };
      dataObj.push(ObjData);
    }
    try {
      timesheetApi.approveRejectBulkTimesheet(dataObj).then(
        (resp) => {
          if (clickedForApprovedRowType === 1 || clickedForApprovedRowType === 2) {
            setImapctBillableDialog(false);
            setSelectedTimesheet([]);
            setClickedForApprovedRow([]);
            setSelectedTimesheetIds([]);
            setClickedForApprovedRowType('');
            fetchTeamTimesheetData();
            toast.success("Timesheet has been approved...");
          }
        },
        (err) => {
          toast.error(err.response.data.error);
          setSelectedTimesheet([]);
        }
      );
    } catch (error) {
      toast.error("Unable to approve timesheet");
    }
  }


  const approveTeamTimesheetData = (rowData, type) => {
    let lhEntries;
    const entries = [];
    setClickedForApprovedRow(rowData);
    setClickedForApprovedRowType(type);

    if (type === 1) {
      selectedTimesheet?.forEach(user => {
        user.Timesheets?.forEach(ts => {
          const isLH = ts?.TimesheetDetails?.some(detail => detail?.categories?.code === "LH");
          if (isLH) {
            entries.push({
              id: ts.id,
              date: ts.date,
              userName: `${user.firstName} ${user.lastName}`
            });
          }
        });
      });
      lhEntries = entries;
    }

    if (type === 2) {
      lhEntries = currentData?.Timesheets?.filter(timesheet =>
        timesheet?.TimesheetDetails.some(detail => detail?.categories?.code === "LH")
      ).map(ts => ({
        date: ts.date,
        id: ts.id
      }));
    }

    if (lhEntries?.length > 0) {
      setImapctBillableDialog(true);
    } else {
      updateBillableActivity();
    }
  };

  const rejectTeamTimesheetData = (rowData, type) => {
    setRejectRowData(rowData);
    setRejectDialog(true);
    setRejectedType(type);
  };

  const rejectTimesheetData = (data) => {
    let statusType = "REJECT";
    var dataObj = [];
    if (rejectedType === 1) {
      selectedTimesheet.map((item, key) => {
        var timeSheetIdList = [];
        for (let key in item.Timesheets) {
          timeSheetIdList.push(item.Timesheets[key].id);
        }
        let ObjData = Object.assign({
          reason: data.reason,
          status: statusType,
          userId: item.id,
          timesheet: timeSheetIdList,
        });
        dataObj.push(ObjData);
      });
    }
    if (rejectedType === 2) {
      let timeSheetIdList = [];
      for (let key in rejectRowData.Timesheets) {
        timeSheetIdList[key] = rejectRowData.Timesheets[key].id;
      }
      let ObjData = {
        reason: data.reason,
        status: statusType,
        userId: rejectRowData.id,
        timesheet: timeSheetIdList,
      };
      dataObj.push(ObjData);
    }
    try {
      // put api call
      timesheetApi.approveRejectBulkTimesheet(dataObj).then(
        (resp) => {
          if (rejectedType === 1 || rejectedType === 2) {
            setSelectedTimesheet([]);
            fetchTeamTimesheetData();
            toast.success("Timesheet has been rejected...");
          }

          if (userRejectData) {
            fetchTeamTimesheetData();
            toast.info(
              rejectRowData.firstName +
              " " +
              rejectRowData.lastName +
              " Timesheet has been rejected..."
            );
          } else {
            fetchEmpReviewTimesheet(selectedUser.id);
          }
        },
        (err) => {
          toast.error("Unable to reject timesheet...");
        }
      );
    } catch (error) {
      toast.error("Unable to reject timesheet...");
    }
  };
  /* Approve Reject Team Members Timesheet End */

  const statusBodyTemplate = (rowData, options) => {
    const d = rowData[options.field];
    let btnStyle = "p-button-primary";
    let result;
    if (TIMESHEET_STATUS) {
      const label = TIMESHEET_STATUS[d];
      switch (label) {
        case "REVIEW":
          btnStyle = "secondary";
          break;
        case "DRAFT":
          btnStyle = "warning";
          break;
        case "APPROVED":
          btnStyle = "success";
          break;
        case "REJECTED":
          btnStyle = "danger";
          break;
        default:
          btnStyle = "secondary";
          break;
      }
      result = (
        <Chip className={classNames("p-button-rounded p-button-secondary", "p-button-" + btnStyle)} label={label} />
      );
    }
    return <>{result}</>;
  };
  /* Grid Action on Column Body End */

  /* Pagination Section Start */
  const onBasicPageChange = (e) => { };

  const onBasicCompliancePageChange = (e) => {
    setBasicComplianceFirst(e.first);
    setSizeCompliance(e.rows);
    setPageCompliance(pageCompliance + e.page);
    setBasicComplianceRows(e.rows);
    var param = {
      pageNum: e.page,
      pageSize: e.rows,
      month: calenderMonth,
      year: calenderYear
    }
    fetchTimesheetCompliance(param);
  };

  const footerCompliance = (
    <React.Fragment>
      <Paginator
        first={basicComplianceFirst}
        rows={basicComplianceRows}
        totalRecords={totalComplianceRecords}
        onPageChange={onBasicCompliancePageChange}
        rowsPerPageOptions={rowsPerPageComplianceOptions}
        paginatortemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalComplianceRecords}"
      ></Paginator>
    </React.Fragment>
  );

  const footer = (
    <React.Fragment>
      <Paginator first={basicFirst} rows={basicRows} totalRecords={totalRecords} onPageChange={onBasicPageChange} rowsPerPageOptions={rowsPerPageOptions} paginatortemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"></Paginator>
    </React.Fragment>
  );
  /* Pagination Section End */

  const clickFilledTimesheetReview = () => {
    setReviewStatus(true);
  }

  /* Review timesheet Data Start */
  const fetchEmpReviewTimesheet = (param = {}) => {
    timesheetApi.getReviewimesheetsData(param).then((resp) => {
      try {
        setEmpReviewTimesheetList(resp.data.data);
        setTimesheetCtreatedUserId(resp.data.data[0].createdBy);
      } catch (error) {
        // Error handle
      }
    });
  };
  /* Review timesheet Data End */

  /* Users By Superior Data Start */
  const getUserInfoBySuperiorIdList = (param = { "pageNum": 0, "pageSize": 2000 }) => {
    timesheetApi.getUsersBySuperior(param).then((resp) => {
      try {
        resp.data.data.map(
          (user, index) =>
          (usersBySuperior[index] = {
            id: user.id,
            name: user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1) + " " + user.lastName.charAt(0).toUpperCase() + user.lastName.slice(1).trimEnd(),
            fullName: user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1) + " " + user.lastName.charAt(0).toUpperCase() + user.lastName.slice(1).trimEnd(),
          })
        );
        setSelectedUser(usersBySuperior[0]);
        if (urlActions === "app") {
          const userId = new URLSearchParams(search).get("id");
          const activeUsers = usersBySuperior.filter((i) => {
            return i.id === parseInt(userId);
          });
          statusAcn === "REVIEW" ? setActiveIndex(0) : statusAcn === "RECALL" ? setActiveIndex(1) : statusAcn === "APPROVED" ? setActiveIndex(2) : statusAcn === "LOCKED" ? setActiveIndex(3) : setActiveIndex(4);
          setSelectedUser(activeUsers[0]);
        }
      } catch (error) {
        // Error handle
      }
    });
  }
  /* Users By Superior Data End */

  const onChangeTab = (e) => {
    setSelectedTimesheet([]);
    setSelectedTab(e?.index);
    if (selectedTab === 0) {
      fetchTeamTimesheetData();
    }
    setTeamTimesheet(true);
    setReviewTimesheet(false);
  };

  /* Onchange Get User Details Start */
  const getEmpDetails = (e) => {
    setSelectedUser(e.value);
    // fetchEmpReviewTimesheet(e.value.id);
  };
  /* Onchange Get user Details End */

  /* Dialog Box for Recall timesheet Start */
  const RejectTimesheetDialog = () => {
    return (
      <Dialog className="pop-up-dialog-recall" header="Reject Timesheet" visible={rejectDialog} style={{ width: '380px' }} onHide={() => setRejectDialog(false)}>
        <RejectTimesheetPopup
          updateRejectRow={(data) => rejectTimesheetData(data)}
          rejectRow={rejectRowData}
          onClose={(e) => {
            setRejectDialog(false);
          }}
        />
      </Dialog>
    );
  };
  /* Dialog Box for Recall timesheet End */

  /* Manager Timesheet Start */

  const [currentData, setCurrentData] = useState({});
  const reviewActionBodyTemplate = (rowData) => {
    const items = [
      { label: "REVIEW", icon: "pi pi-eye", command: () => { clickFilledTimesheetReview(); navigate("/timesheets?action=app&id=" + currentData.id + "&status=REVIEW"); }, },

      { label: "APPROVE", icon: "pi pi-check", command: () => { approveTeamTimesheetData(currentData, 2); }, },

      { label: "REJECT", icon: "pi pi-times", command: () => { rejectTeamTimesheetData(currentData, 2); }, },

      { label: "Create Timesheet", icon: "pi pi-plus-circle", command: (e) => { clickFilledTimesheetReview(); navigate("/timesheets?action=app&id=" + currentData.id + "&status=CREATE"); }, },

      { label: "Approved Timesheets", icon: "pi pi-check-circle", command: (e) => { clickFilledTimesheetReview(); navigate("/timesheets?action=app&id=" + currentData.id + "&status=APPROVED"); }, },

      { label: "Locked Timesheets", icon: "pi pi-lock", command: (e) => { clickFilledTimesheetReview(); navigate("/timesheets?action=app&id=" + currentData.id + "&status=LOCKED"); }, },
    ];

    return (
      <>
        <Menu id={"m-" + rowData.id} model={items} popup ref={menu} style={{ width: "14rem" }} />
        <Button className="p-button-rounded p-button-text" id={"b-" + rowData.id} icon="pi pi-ellipsis-v" onClick={(event) => { setCurrentData(rowData); menu.current.toggle(event); }} aria-controls={"m-" + rowData.id} aria-haspopup />
      </>
    );
  };
  /* Manager Timesheet End */

  /* Team Details Timesheet List Start */
  const userOptionTemplate = (data) => {
    return (
      <div className="user-item grid">
        <div className="icon">
          {data.icon == null ? (
            <span>{data.name.substr(0, 1)}</span>
          ) : (
            <img src={data.icon} />
          )}
        </div>
        <div className="label col">{data.name}</div>
      </div>
    );
  };

  const selectedUserTemplate = (data, props) => {
    if (data) {
      return (
        <div className="user-item user-item-value grid">
          <div className="icon">
            {data.icon == null ? (
              <span>{data.name.substr(0, 1)}</span>
            ) : (
              <img src={data.icon} />
            )}
          </div>
          <div className="label col p-2">{data.name}</div>
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  const changeUser = (op) => {
    const curIndex = usersBySuperior.indexOf(selectedUser);
    let result = {};
    if (op == 1) {
      // Next Action
      if (curIndex < usersBySuperior.length - 1)
        result = usersBySuperior[curIndex + 1];
      else result = usersBySuperior[0];
    } else {
      // Previous Action
      if (curIndex > 0) result = usersBySuperior[curIndex - 1];
      else result = usersBySuperior[usersBySuperior.length - 1];
    }
    setSelectedUser(result);
    // fetchEmpReviewTimesheet(result.id);
  };

  /* Team Details Timesheet List End */
  const imageBodyTemplate = (item) => {
    return (
      <div className="flex align-items-center gap-2">
        {item?.photo === "" || item?.photo === null ? (
          <span className="photo-span" style={{ height: "35px", width: "35px", borderRadius: "50%", border: "2px solid #d7e9ff", display: "flex", alignItems: 'center', justifyContent: 'center', fontSize: "18px", fontWeight: "600", color: "#1369b6", padding: '5px', paddingTop: '1px' }}>
            {item.firstName.toUpperCase().substr(0, 1)}
            {item.lastName.toUpperCase().substr(0, 1)}
          </span>
        ) : (
          <img style={{ height: "40px", width: "40px", borderRadius: "50%", border: "3px solid #d7e9ff", Top: "16px", bottom: "16px", left: "16px", }} src={imgPath + item?.photo || ""} alt="" />
        )}
        <div className='capitalize'>{item.firstName + " " + item.lastName}</div>
      </div>
    );
  };

  const filledBodyTemplate = (rowData) => {
    let dateRangeList = [];
    rowData.Timesheets.map((el) => {
      dateRangeList.push(el?.date);
    });
    let dateListRange = dateRangeList.sort();
    return dateListRange[0] + " - " + dateListRange[dateListRange.length - 1];
  };

  const rowClass = (rowData) => {
    let holidayList = [];
    rowData.Timesheets.map((el) => {
      holidayList.push(el?.holidayRegion);
    });
    let holidayListArr = holidayList.filter(function (element) {
      return element !== null;
    });
    return {
      'row-accessories': holidayListArr.length > 0
    }
  }

  const onChangeCustomCalender = (e) => {
    setDateRange(e.value);
    let startDate = Util.dateConverterForAttendance(e.value[0]);
    let endDate = Util.dateConverterForAttendance(e.value[1]);
    let peram = { startdate: startDate, enddate: endDate };
    try {
      timesheetApi.filterTimeSheet(peram).then(
        (resp) => {
          toast.success("Data Filtered");
        },
        (err) => {
          toast.error(err.response.data.error);
        }
      );
    } catch (error) {
      toast.error("Unable to filterdata");
    }
  };

  const complianceClick = () => {
    let d;
    navigate("/timesheets");
    setReviewStatus(false);
    setCompMonth(new Date());
    setCompliance(true);
    d = new Date(compMonth);
    const m = moment(d).format("MM");
    const y = moment(d).format("YYYY");
    setCalenderMonth(m);
    setCalenderYear(y);
    fetchTimesheetCompliance({ "pageNum": 0, "pageSize": sizeCompliance, "month": m, "year": y });
  };
  const approvalTimesheetClick = () => {
    navigate("/timesheets");
    setReviewStatus(false);
    setfilledTimesheet(true);
    fetchTeamTimesheetData();
  }


  const filterComplianceData = (e) => {
    let d;
    if (e != null) {
      setCompMonth(e.value);
      d = new Date(e.value);
    } else {
      d = new Date(compMonth);
    }
    const m = moment(d).format("MM");
    const y = moment(d).format("YYYY");
    setCalenderMonth(m);
    setCalenderYear(y);
    fetchTimesheetCompliance({ "pageNum": 0, "pageSize": sizeCompliance, "month": m, "year": y })
  }

  const fetchTimesheetCompliance = (param = {}) => {
    if (param.pageNo === undefined) {
      setPageCompliance(0);
      setContentComplianceFirst(0);
    }
    timesheetApi.timesheetCompliance(param).then((resp) => {
      setComplianceData(resp.data.data);
      setTotalComplianceRecords(resp.data.totalElement);
    });
  };

  const renderCompliance = (d) => {
    const complianceValue = parseInt(d.compliance); // Convert string to integer
    const isCompliance = complianceValue >= 100.00;
    const colorClass = isCompliance ?
      <span style={{ color: 'green', fontWeight: 'bold' }}>{d.compliance}</span> :
      <span style={{ color: 'red', fontWeight: 'bold' }}>{d.compliance}</span>
    return colorClass;
  };

  const getUserWiseTimesheet = () => {
    navigate("/timesheets");
    setReviewStatus(false);
    setUserWiseTimesheet(true);
    getUserInfoBySuperiorIdList();
  }

  const clickDayWiseTimesheet = () => {
    navigate("/timesheets");
    setReviewStatus(false);
    setDayWiseReport(true);
  }

  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <div style={{display:"flex", flexWrap:"wrap", gap:"5px"}}>
          <ProtectedSection permissions={[TIMESHEET_TEAM_APPROVALS]}>
            <Button label="Timesheet Approvals" className="p-button-success" onClick={() => { approvalTimesheetClick(); setCompliance(false); setUserWiseTimesheet(false); }} />
          </ProtectedSection>

          <ProtectedSection permissions={[TIMESHEET_TEAM_COMPLIANCE]}>
            <Button label="Timesheet Compliance" className="p-button-warning" onClick={() => { complianceClick(complianceData, "complianceData" + moment(new Date(compMonth), "DD-YYYY")); setfilledTimesheet(false); setUserWiseTimesheet(false); }} />
          </ProtectedSection>

          <ProtectedSection permissions={[TIMESHEET_TEAM_USERWISE]}>
            <Button label="User Wise Timesheet" className="p-button-help" onClick={() => { setfilledTimesheet(false); setCompliance(false); setDayWiseReport(false); getUserWiseTimesheet(); }} />
          </ProtectedSection>

          <ProtectedSection permissions={[TIMESHEET_TEAM_DAYWISE]}>
            <Button label="Day Wise Timesheet" className="p-button-primary" onClick={() => { setfilledTimesheet(false); setCompliance(false); setUserWiseTimesheet(false); clickDayWiseTimesheet() }} />
          </ProtectedSection>

        </div>
      </React.Fragment>
    )
  }

  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        {compliance && (
          <span>
            <Calendar value={compMonth} onChange={filterComplianceData} view="month" dateFormat="mm-yy" yearNavigator yearRange={"2010:" + new Date().getFullYear().toString()} showIcon />
          </span>
        )}
        {filledTimesheet && (
          <div>
            <Button label="Approve All" className="p-button-rounded" type="button" onClick={() => approveTeamTimesheetData("", 1)} disabled={selectedTimesheet.length === 0} />
            <Button label="Reject All" className="p-button-rounded p-button-secondary ml-2" type="button" onClick={() => rejectTeamTimesheetData("", 1)} disabled={selectedTimesheet.length === 0}
            />
          </div>
        )}
        {showCalender && (
          <div>
            <label htmlFor="range"></label>{" "}
            <Calendar id="range" value={dateRange} onChange={(e) => onChangeCustomCalender(e)} selectionMode="range" readOnlyInput dateFormat="dd/mm/yy" mask="99/99/9999" showIcon placeholder="Select Period" />
          </div>
        )}
      </React.Fragment>
    )
  }

  const hoursRoundOff = (item) => {
    return item.totalHour?.toFixed(2);
  };

  const workingDayCount = (item) => {
    const allDetails = item?.Timesheets.map(ts => ts?.TimesheetDetails).flat();
    const OH_count = allDetails?.filter(detail => detail?.categories?.code === "OH").length;
    return OH_count;
  }

  const leaveDayCount = (item) => {
    const allDetails = item?.Timesheets.map(ts => ts?.TimesheetDetails).flat();
    const LH_count = allDetails?.filter(detail => detail?.categories?.code === "LH").length;
    return LH_count;
  }

  const ManagerTimesheetList = () => {
    let holidayList = [];
    teamTimesheetList.map((el) => {
      el.Timesheets.filter((timesheet) => {
        if (timesheet.holidayRegion !== null && timesheet.isHoliday === true)
          return holidayList.push(timesheet);
      })
    });
    const uniqueHolidays = [...new Map(holidayList.map(v => [v.holidayName, v])).values()];
    return (
      <React.Fragment>
        <Toolbar
          className="mb-2"
          left={leftToolbarTemplate}
          right={rightToolbarTemplate}
        ></Toolbar>
        <h1>
          Team Members - {" "}
          {compliance ? (
            <span className="text-warning">Compliance</span>
          ) : filledTimesheet ? (
            <span className="text-success">Awaiting Approvals</span>
          ) : dayWiseReport ? (
            <span className="text-success">Day Wise Timesheet Report</span>
          ) : (
            <span className="text-success">User Wise Timesheet</span>
          )}
        </h1>
        {
          filledTimesheet &&
          uniqueHolidays.length > 0 &&
          <div className="row col-12 " style={{ backgroundColor: 'rgb(196 250 205)', color: '#000' }}>
            <label htmlFor="timesheet24hrs">
              {
                uniqueHolidays.map((hl) => {
                  return <span style={{ fontWeight: '600' }}>{hl.holidayName}&nbsp;({hl.date})&nbsp;&nbsp;&nbsp;</span>
                })
              }
            </label>
          </div>
        }
        {compliance ? (
          <div style={{ background: "#f59e0b", padding: "2px" }}>
            <DataTable dataKey="id" responsiveLayout="scroll" resizableColumns columnResizeMode="fit" scrollable="horizontal" stripedRows value={complianceData} footer={footerCompliance}>
              <Column field="name" className='capitalize' header="Name"></Column>
              <Column field="ecn" header="ECN"></Column>
              <Column field="twd" header="Working Days"></Column>
              <Column field="timesheetFilled" header="Filled"></Column>
              <Column field="timesheetNotFilled" header="Not Filled"></Column>
              <Column field="awaitingApproval" header="Awaiting Approval"></Column>
              <Column field="compliance" headerStyle={{ width: "20px" }} style={{ textAlign: "right" }} header="Compliance" body={renderCompliance}></Column>
            </DataTable>
          </div>
        ) : filledTimesheet ? (
          <div className="datatable-style-demo" style={{ background: "#22c55e", padding: "2px" }}>
            <DataTable dataKey="id" responsiveLayout="scroll" resizableColumns columnResizeMode="fit" scrollable="horizontal" stripedRows ref={dt} selectionMode={rowClick ? null : "checkbox"} value={teamTimesheetList} selection={selectedTimesheet} onSelectionChange={(e) => setSelectedTimesheet(e.value)} footer={footer} rowClassName={rowClass}>
              <Column selectionMode="multiple" headerStyle={{ width: "8rem" }} exportable={false}></Column>
              <Column field="firstName" body={imageBodyTemplate} header="Name" style={{ minWidth: "8rem" }}></Column>
              <Column field="ecn" header="Employee ID" style={{ minWidth: "8rem" }}></Column>
              <Column field="timsheetFilled" body={filledBodyTemplate} header="Timesheet Range" style={{ minWidth: "8rem" }}></Column>
              <Column field="status" header="Status" body={statusBodyTemplate} style={{ minWidth: "8rem" }}></Column>
              <Column field="" header="Total Hours" body={hoursRoundOff} style={{ minWidth: "8rem" }}></Column>
              <Column field="" header="Working" body={workingDayCount} style={{ minWidth: "8rem" }}></Column>
              <Column field="" header="Leave" body={leaveDayCount} style={{ minWidth: "8rem" }}></Column>
              <Column field="" header="ACTIONS" body={reviewActionBodyTemplate} style={{ minWidth: "10rem" }}
              ></Column>
            </DataTable>
          </div>
        ) : dayWiseReport ? (
          <div className="datatable-style-demo" style={{ background: "#254c91", padding: "2px" }}>
            <DayWiseTimesheetReport />
          </div>
        ) : (
          <React.Fragment>
            <Card>
              <div className="formgrid grid" style={{alignItems: 'center', justifyContent: 'space-between'}}>
                <div className="field">
                  <Button label="Previous User" className="p-button-rounded p-button-secondary" icon="pi pi-angle-left" onClick={() => changeUser(-1)} />
                </div>

                <div className="field">
                  <Dropdown value={selectedUser} options={usersBySuperior} onChange={(e) => getEmpDetails(e)} optionLabel="name" className="user-options capitalize" placeholder="Select a User" style={{ width: "320px" }} filter itemTemplate={userOptionTemplate} valueTemplate={selectedUserTemplate} />
                </div>

                <div className="field">
                  <Button label="Next User" className="p-button-rounded" icon="pi pi-angle-right" iconPos="right" onClick={() => changeUser(1)} />
                </div>
              </div>
            </Card>

            <div style={{ background: "#A855F7", padding: "2px" }} className="mt-1">
              <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} style={{ width: "100%" }}>
                <TabPanel header="Review Timesheets">
                  <ReviewTeamTimesheet userData={selectedUser} />
                </TabPanel>

                <TabPanel header="Review Recall Timesheets">
                  <ReviewRecallTimesheet userData={selectedUser} />
                </TabPanel>

                <TabPanel header="Approved Timesheets">
                  <ApproveTeamTimesheet userData={selectedUser} />
                </TabPanel>

                <TabPanel header="Locked Timesheets">
                  <LockedTeamTimesheet userData={selectedUser} />
                </TabPanel>

                <TabPanel header="Create Timesheet">
                  <CreateUserTimesheetByManager userData={selectedUser} />
                </TabPanel>
              </TabView>
            </div>
          </React.Fragment>
        )}
        {RejectTimesheetDialog()}
        {BillableImpactDialog()}
      </React.Fragment>
    );
  };

  return (
    <TabView activeIndex={selectedTab} onTabChange={(e) => { onChangeTab(e); }}>
      <TabPanel header="My Timesheet">
        <React.Fragment>
          {EmployeeManagerTimesheet()}
        </React.Fragment>
      </TabPanel>

      <TabPanel header="Team Timesheet">
        {teamTimesheet && ManagerTimesheetList()}
      </TabPanel>

      {/* <ProtectedSection permissions={[TIMESHEET_INVOICE_VIEW]}> */}
      <TabPanel header="Invoice Data">
        <Card>
          {InvoiceTimesheet()}
        </Card>
      </TabPanel>
      {/* </ProtectedSection> */}
    </TabView>
  );
};

export default ManagerTimesheet;